"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var ChevronDown = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: "8", viewBox: "0 0 14 8", width: "15", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "m6.99970487 8c-.26266844 0-.51373853-.10441736-.69590079-.28864418l-6.03455145-6.11805948c-.36910032-.37443934-.35750197-.97034991.02729023-1.33082259.38410994-.35980761.99541103-.34850127 1.3651936.02660315l5.33796841 5.41174584 5.33865063-5.41174584c.3691003-.37510442.9810837-.38641076 1.3651936-.02660315.3847922.36047268.3963906.95638325.026608 1.33082259l-6.03386919 6.11805948c-.18216227.18422682-.43391461.28864418-.69658304.28864418", fill: "currentColor", fillRule: "evenodd" })));
};
exports.default = ChevronDown;
//# sourceMappingURL=ChevronDown.js.map